import { render, staticRenderFns } from "./CardProduct.vue?vue&type=template&id=c370ed22"
import script from "./CardProduct.vue?vue&type=script&lang=js"
export * from "./CardProduct.vue?vue&type=script&lang=js"
import style0 from "./CardProduct.vue?vue&type=style&index=0&id=c370ed22&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports